var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, computed, action } from "mobx";
import { BasicPulseBetViewModel } from "../../ViewModel";
import { WinningsDataModel } from "../../WinningsDataModel";
import { PulseFreeBetInfo } from "../../PulseFreeBetInfo";
import { EventsManager } from "sb-js-extends";
var PulseBetMarketComponentData = /** @class */ (function (_super) {
    __extends(PulseBetMarketComponentData, _super);
    function PulseBetMarketComponentData(stakeInputData, pulseBetMetadata, gameProgressInMilli, freePulseBets, placeBetHandler) {
        var _this = _super.call(this, stakeInputData.stakeValue, pulseBetMetadata, gameProgressInMilli) || this;
        _this.prevStakeValue = stakeInputData.stakeValue;
        _this.eventsManager = new EventsManager();
        _this.stakeInputData = stakeInputData;
        _this.placeBetHandler = _this.placeBetHandler.bind(_this);
        _this.externalPlaceBetHandler = placeBetHandler ? placeBetHandler : function () { };
        _this.onStakeChangeFading = false;
        _this.freePulseBets = freePulseBets;
        _this.freeBetsEnabled = false;
        var count = 1;
        _this.winings = {
            winnings: _this.wrappedCalculatedPeriods.map(function (period) { return ({
                winningValue: period.formatedWin,
                winningStatus: /*istanbul ignore next */ period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                periodNumber: count++
            }); }),
            branchID: _this.pulseBetMetadata.branchID
        };
        return _this;
    }
    PulseBetMarketComponentData.prototype.setWiningsBy = function (freePulseBetId) {
        var selectedFreeBet = this.freePulseBets.bonusInfo.find(function (x) { return x.bonusId === freePulseBetId; });
        if (selectedFreeBet) {
            this.freePulseBets.selectedFreeBetId = selectedFreeBet.bonusId;
            this.stakeInputData.stakeValue = selectedFreeBet.amount;
            this.setWinings(selectedFreeBet.amount, selectedFreeBet);
        }
    };
    PulseBetMarketComponentData.prototype.setWinings = function (amount, bonusInfo) {
        var periods = this.calculatedPeriodHelperDependency.wrappedCalculatedPeriodsStateless(amount, this.pulseBetMetadata, bonusInfo);
        this.winings.winnings = periods.map(function (period, index) { return ({
            winningValue: period.formatedWin,
            winningStatus: /*istanbul ignore next */ period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
            periodNumber: index
        }); });
        this.onStakeChangeFading = true;
        this.eventsManager.dispatchEvent("onSetStake", { marketTypeId: this.pulseBetMetadata.typeId }, true);
    };
    Object.defineProperty(PulseBetMarketComponentData.prototype, "wrappedCalculatedPeriods", {
        get: function () {
            var _this = this;
            var bonusInfo;
            if (this.freePulseBets && this.freePulseBets.selectedFreeBetId) {
                bonusInfo = this.freePulseBets.bonusInfo.find(function (x) { return x.bonusId === _this.freePulseBets.selectedFreeBetId; });
            }
            return this.calculatedPeriodHelperDependency.wrappedCalculatedPeriodsStateless(this.stakeInputData.stakeValue, this.pulseBetMetadata, bonusInfo);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PulseBetMarketComponentData.prototype, "periodFrames", {
        get: function () {
            return this.wrappedCalculatedPeriods.map(function (p) { return p.relativeRangeFormatted; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PulseBetMarketComponentData.prototype, "hasFreeBetOptions", {
        get: function () {
            return this.freeBetOptions.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PulseBetMarketComponentData.prototype, "hasSelectedFreeBet", {
        get: function () {
            var _this = this;
            return this.freePulseBets.bonusInfo.some(function (v) { return v.bonusId === _this.freePulseBets.selectedFreeBetId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PulseBetMarketComponentData.prototype, "freeBetOptions", {
        get: function () {
            var _this = this;
            return this.freePulseBets.bonusInfo.map(function (v, i) { return ({
                id: v.bonusId,
                text: v.title,
                isSelected: _this.hasSelectedFreeBet ? v.bonusId === _this.freePulseBets.selectedFreeBetId : i === 0
            }); });
        },
        enumerable: true,
        configurable: true
    });
    PulseBetMarketComponentData.prototype.updateFreePulseBets = function (newBonusInfo) {
        var _this = this;
        if (!newBonusInfo.find(function (x) { return x.bonusId === _this.freePulseBets.selectedFreeBetId; })) {
            this.freePulseBets.selectedFreeBetId = "";
        }
        (this.freePulseBets.bonusInfo).replace(newBonusInfo);
    };
    PulseBetMarketComponentData.prototype.onFreePulseBetSelect = function (selectedFreeBetId) {
        this.setWiningsBy(selectedFreeBetId);
        var dispatchData = {
            marketTypeId: this.freePulseBets.marketTypeId,
            freeBetId: selectedFreeBetId
        };
        this.eventsManager.dispatchEvent("onFreePulseBetSelect", dispatchData, true);
    };
    PulseBetMarketComponentData.prototype.toggleStakeType = function () {
        this.freeBetsEnabled = !this.freeBetsEnabled;
        if (this.freeBetsEnabled) {
            var tempValue = this.prevStakeValue;
            this.prevStakeValue = this.stakeInputData.stakeValue;
            this.stakeInputData.stakeValue = tempValue;
            if (this.freeBetOptions && this.freeBetOptions[0]) {
                this.onFreePulseBetSelect(this.freeBetOptions[0].id);
            }
            else {
                this.setWinings(this.stakeInputData.stakeValue);
            }
        }
        else {
            this.stakeInputData.stakeValue = this.prevStakeValue;
            if (this.freePulseBets.selectedFreeBetId) {
                this.resetFreePulseBets();
            }
            this.setWinings(this.stakeInputData.stakeValue);
        }
    };
    PulseBetMarketComponentData.prototype.resetFreePulseBets = function () {
        this.freePulseBets.selectedFreeBetId = "";
        this.onFreePulseBetSelect(this.freePulseBets.selectedFreeBetId);
    };
    PulseBetMarketComponentData.prototype.placeBetHandler = function () {
        // it's overriden in constructor and in PulseBettingStore
    };
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], PulseBetMarketComponentData.prototype, "onStakeChangeFading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], PulseBetMarketComponentData.prototype, "freeBetsEnabled", void 0);
    __decorate([
        observable,
        __metadata("design:type", WinningsDataModel)
    ], PulseBetMarketComponentData.prototype, "winings", void 0);
    __decorate([
        observable,
        __metadata("design:type", PulseFreeBetInfo)
    ], PulseBetMarketComponentData.prototype, "freePulseBets", void 0);
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "wrappedCalculatedPeriods", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "periodFrames", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "hasFreeBetOptions", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "hasSelectedFreeBet", null);
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "freeBetOptions", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketComponentData.prototype, "updateFreePulseBets", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketComponentData.prototype, "onFreePulseBetSelect", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketComponentData.prototype, "toggleStakeType", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketComponentData.prototype, "resetFreePulseBets", null);
    return PulseBetMarketComponentData;
}(BasicPulseBetViewModel));
export { PulseBetMarketComponentData };
//# sourceMappingURL=PulseBetMarketComponentData.js.map